<template>
  <v-layout align-center v-if="lastTransaction" style="gap: 5px" class="transaction-indicator">
    <v-tooltip nudge-bottom class="d-flex">
      <v-layout slot="activator" v-if="lastTransaction.from_user">
        <v-layout column justify-center align-center style="gap: 5px">
          <v-layout align-center style="font-size: 10px; gap: 1px">
            <span
              class="mr-1 grey--text user-text" style="line-height: 0.9">
              {{ shortName(lastTransaction.from_user.name) }}
            </span>
            <v-avatar size="22" color="grey lighten-3">
              <v-img
                v-if="!isEmpty(lastTransaction.from_user.avatar)"
                :src="lastTransaction.from_user.avatar"
              />
              <span v-else>{{ acronym(lastTransaction.from_user.name) }}</span>
            </v-avatar>
          </v-layout>
          <v-chip
            v-if="lastTransaction.origin"
            small
            outline
            class="admin-unit-badge admin-unit-badge--main"
            :style="{
                  color: getAdminUnitColor(lastTransaction.origin),
                  borderColor: getAdminUnitColor(lastTransaction.origin),
                  backgroundColor: 'transparent'
                }"
          >
            {{ lastTransaction.origin.abbreviation || lastTransaction.origin.name }}
          </v-chip>
          <!--          <span-->
          <!--            class="subtitle grey&#45;&#45;text tex&#45;&#45;lighten-3" style="line-height: 0.9">-->
          <!--                      {{ shortName(lastTransaction.from_user.role.name) }}-->
          <!--                    </span>-->
        </v-layout>
      </v-layout>
      <p><strong>Origem:</strong> {{ lastTransaction.origin.name }}</p>
      <p v-if="lastTransaction.from_user"><strong>De:</strong> {{ lastTransaction.from_user.name }}</p>
      <p v-if="lastTransaction.from_user"><strong>Cargo:</strong> {{ lastTransaction.from_user.role.name }}</p>
      <p><strong>Status: </strong> {{ lastTransaction.received ? 'Processo Recebido' : 'Aguardando Recebimento' }}</p>
      <p><strong>Enviado em:</strong> {{ lastTransaction.created_at | formatDateWithHours }}</p>
    </v-tooltip>

    <div style="display: flex; flex-direction: column; align-items: center">
      <div><br/></div>
      <v-icon class="mx-1" color="grey lighten-2">mdi-ray-start-arrow</v-icon>
    </div>

    <v-tooltip nudge-bottom>
      <v-layout slot="activator" align-center v-if="lastTransaction.to_user">
        <v-layout column justify-center align-center style="gap: 5px">
          <v-layout align-center justify-center style="font-size: 10px; gap: 1px">
            <v-avatar size="22" color="grey lighten-3">
              <v-img
                v-if="!isEmpty(lastTransaction.to_user.avatar)"
                :src="lastTransaction.to_user.avatar"
              />
              <span v-else>{{ acronym(lastTransaction.to_user.name) || acronym(lastTransaction.destination.name) }}</span>
            </v-avatar>
            <span
              class="user-text grey--text mr-1" style="line-height: 0.9">
              {{ shortName(lastTransaction.to_user.name) || shortName(lastTransaction.destination.name) }}
            </span>
          </v-layout>
          <v-chip
            v-if="lastTransaction.destination"
            small
            outline
            class="mr-2 admin-unit-badge admin-unit-badge--main"
            :style="{
                  color: getAdminUnitColor(lastTransaction.destination),
                  borderColor: getAdminUnitColor(lastTransaction.destination),
                  backgroundColor: 'transparent',
                  width: '100%'
                }"
          >
            {{ lastTransaction.destination.abbreviation || lastTransaction.destination.name }}
          </v-chip>
        </v-layout>
      </v-layout>
      <v-layout slot="activator" align-center v-else>
        <v-layout column justify-center style="gap: 5px">
          <div style="display: flex; align-items: center; justify-content: center" class="text--lighten-2">
            <v-avatar size="22" color="grey lighten-3">
              <span data-transact-type="no-to-user">?</span>
            </v-avatar>
            <span
              class="sm1 user-text ml-1 grey--text text--lighten-1"
              style="line-height: 0.9; font-style: italic;">
              --
            </span>
          </div>

          <v-layout align-center>
            <v-chip
              v-if="lastTransaction.destination"
              small
              outline
              class="mr-2 admin-unit-badge admin-unit-badge--main"
              :style="{
                  color: getAdminUnitColor(lastTransaction.destination),
                  borderColor: getAdminUnitColor(lastTransaction.destination),
                  backgroundColor: 'transparent'
                }"
            >
              {{ lastTransaction.destination.abbreviation || lastTransaction.destination.name }}
            </v-chip>
          </v-layout>
        </v-layout>
      </v-layout>
      <p><strong>Destino:</strong> {{ lastTransaction.destination.name }}</p>
      <template v-if="lastTransaction.to_user">
        <p><strong>Para:</strong> {{ lastTransaction.to_user.name }}</p>
        <p><strong>Cargo:</strong> {{ lastTransaction.to_user.role.name }}</p>
      </template>
      <template v-else>
        <p><strong>Para:</strong> {{ lastTransaction.destination.name }} <small>(setor)</small></p>
      </template>
      <p><strong>Status: </strong> {{ lastTransaction.received ? 'Processo Recebido' : 'Aguardando Recebimento' }}</p>
      <p><strong>Enviado em:</strong> {{ lastTransaction.created_at | formatDateWithHours }}</p>
    </v-tooltip>
  </v-layout>
  <v-chip v-else>Pasta não tramitada</v-chip>
</template>

<script>
import {isEmpty} from 'lodash';
import shortName from '@/utils/short-name';
import acronym from '@/utils/acronym';
import adminUnitHandling from '@/mixins/admin-unit-handling';
import getColorByText from '@/assets/utils/colorByText';

export default {
  name: 'TransactionIndicator',
  mixins: [adminUnitHandling],
  props: ['folder'],
  data() {
    return {
      isEmpty,
      shortName,
      acronym,
    };
  },
  computed: {
    lastTransaction() {
      return this.folder.last_transaction;
    },
  },
  methods: {
    getAdminUnitColor(unit) {
      if (!unit) return '#000000';
      return getColorByText(unit.name);
    },
  },
};
</script>

<style scoped>
.user-text {
  font-size: 12px;
}

.folder-id {
  font-size: 12px;
}

.folder-type-border {
  position: absolute;
  height: 100%;
  left: 1px;
  border-radius: 3px 0 0 3px;
  border-left: 5px solid;
  transition: ease-in-out .15s;
}

.mdi-folder-open {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}

.role {
  font-size: 12px;
}

.tooltip-content {
  text-align: left;

  p {
    margin: 4px 0;
    font-size: 12px;
    line-height: 1.4;
  }

  strong {
    font-weight: 600;
    color: #e8dada;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/TransactionIndicator.vue